<div class="modal-header">
  <h3 class="modal-title">{{ contentConfig.textsKey + 'Title' | translate }}</h3>
  @if (!contentConfig.hideCancelBtn) {
    <button type="button" class="close" data-cy="CloseModal" (click)="activeModal.dismiss(actionTypes.CANCEL)">
      <i class="far fa-times"></i>
    </button>
  }
</div>
<div class="modal-body">
  <p>{{ contentConfig.textsKey + 'Question' | translate: contentConfig.questionParams }}</p>
</div>
<div class="modal-footer modal-footer-reverse">
  <button type="button" class="btn btn-secondary" ngbAutofocus
  (click)="activeModal.close(actionTypes.VALIDATE)">{{ (contentConfig.confirmBtnText || 'CommonTexts.Yes') | translate }}</button>
  @if (!contentConfig.hideCancelBtn) {
    <button type="button" class="btn btn-default"
    (click)="activeModal.dismiss(actionTypes.CANCEL)">{{ (contentConfig.cancelBtnText || 'CommonTexts.No') | translate }}</button>
  }
</div>
